import React from 'react';
import { Button } from "react-bootstrap";
import { Form } from 'react-bootstrap';
const StepThree = ({ setActiveStep }) => {
    return (
        <>
            <div className="row justify-content-center">
                <div className="col-xl-9">
                    <div className="card custom-card">
                        <div className="card-body">
                            <h5 className="text-center">Drug Test Information</h5>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Date of Last Drug Test:</Form.Label>
                                                <Form.Control type="date" placeholder="Enter Date of Last Drug Test" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Drug Test Result:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Drug Test Result" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Drug Test Provider Name:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Drug Test Provider Name" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Facility Contact Information:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Facility Contact Information" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Link to Government Clearinghouse:</Form.Label>
                                                <Form.Control type="url" placeholder="Enter Link to Government Clearinghouse" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Consent for Drug Test Result Submission:</Form.Label>
                                                <Form.Check
                                                    type="checkbox"
                                                    label="I give consent for drug test result submission"
                                                />
                                            </Form.Group>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 d-flex mb-3">
                                    <Button
                                        variant="secondary"
                                        className="mt-auto w-100"
                                        onClick={() => setActiveStep(1)}
                                    >
                                        Previous
                                    </Button>
                                </div>
                                <div className="col-lg-3 d-flex mb-3">
                                    <Button
                                        variant="primary"
                                        className="text-white mt-auto w-100"
                                        onClick={() => setActiveStep(3)}
                                    >
                                        Next
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StepThree;
